import { Checkbox, PageTabsContent } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { PHONE_CALL_REDACTION_GROUPS, isRedactionGroupChecked } from "./roleEditorConfig";
import { RoleEditor } from "./useEditRoleDialog";
import { useRoleEditorLabels } from "./useRoleEditorLabels";

export interface RoleAdminTabContentProps {
  editor: RoleEditor;
}

export const RoleAdminTabContent = ({ editor }: RoleAdminTabContentProps) => {
  const { t } = useTranslation("settings");
  const labels = useRoleEditorLabels();
  const { draft, toggleRedactionGroup } = editor;

  return (
    <PageTabsContent
      value="admin"
      className="px-6 py-4 space-y-6 overflow-y-auto"
      style={{ maxHeight: "min(80vh, 900px)" }}
    >
      <div className="space-y-1">
        <h3 className="text-sm font-medium">{t("Field Redactions")}</h3>
        <p className="text-xs text-muted-foreground">
          {t("Redacted fields are removed from API responses and the UI for users with this role.")}
        </p>
      </div>

      <div className="space-y-3">
        <h4 className="text-sm font-medium">{t("Phone Call Field Redactions")}</h4>
        <div className="space-y-3">
          {PHONE_CALL_REDACTION_GROUPS.map((group) => (
            <label key={group.key} className="flex items-start gap-2 text-sm">
              <Checkbox
                checked={isRedactionGroupChecked(draft.fieldRedactions, group.fields)}
                onCheckedChange={(checked) => toggleRedactionGroup(group.fields, checked === true)}
                className="mt-0.5"
              />
              <span>{labels.redactions[group.key]}</span>
            </label>
          ))}
        </div>
      </div>
    </PageTabsContent>
  );
};
